<template>
    <div class="draggable rounded" v-if="(!section.omitted) || showOmitted ">
        <div class="flex items-center mb-1">
            <div class="w-6 flex-shrink-0">
            </div>
            <div class="flex-grow">
                <div
                    class="whitespace-pre-line text-lg m-0 px-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative focus:z-10 resize-none bg-white"
                    :class="((section.omitted) ? ' text-red-600 line-through':'')"
                    v-text="section.name"
                ></div>
            </div>
            <div class="w-6 flex-shrink-0 ml-2 self-start py-1.5">
            </div>
        </div>
        <scope-of-works-task v-for="task in section.tasks"
                             :section="section"
                             :key="task.id"
                             :showItemProgress="showItemProgress"
                             :search="search"
                             :show-omitted="showOmitted"
                             :latest-progress-report="latestProgressReport"
                             :task="task"></scope-of-works-task>
    </div>
</template>

<script>
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import UiDropdown from "../../ui/UiDropdown.vue";
import UiDropdownDivider from "../../ui/UiDropdownDivider.vue";
import ScopeOfWorksTask from "./ScopeOfWorksTask.vue";

export default {
    components: {
        ScopeOfWorksTask,
        UiDropdownDivider,
        UiDropdown,
        UiDropdownItem,
    },
    props: {
        search: '',
        section: Object,
        showItemProgress: Boolean,
        showOmitted: Boolean,
        latestProgressReport: Object,
    },
    data() {
        return {}
    },
    computed: {},
    methods: {},
}
</script>
